/**
 * 中国大陆 18 位身份证号校验（含校验位，与后端 IdCardUtil.isValid 对齐）
 */
export function isValidIdCardNumber(raw) {
  const id = String(raw || "")
    .trim()
    .toUpperCase();
  if (!/^\d{17}[\dX]$/.test(id)) {
    return false;
  }
  const weights = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2];
  const checks = ["1", "0", "X", "9", "8", "7", "6", "5", "4", "3", "2"];
  let sum = 0;
  for (let i = 0; i < 17; i++) {
    sum += Number(id[i]) * weights[i];
  }
  return checks[sum % 11] === id[17];
}

/**
 * OCR / 核对表单：姓名、证件号、有效期是否齐全可用。
 * @returns {string|null} 错误文案，通过返回 null
 */
export function validateIdCardProfileFields({
  name,
  idNumber,
  startDate,
  endDate,
} = {}) {
  if (!(name || "").trim()) {
    return "请填写姓名";
  }
  if (!isValidIdCardNumber(idNumber)) {
    return "身份证号不完整或校验位不正确";
  }
  return validateIdCardValidPeriod(startDate, endDate);
}

/**
 * OCR 识别完整性：起止可解析且起≤止即可（不过滤过期；过期在确认/保存再拦）
 * @returns {string|null}
 */
export function validateIdCardValidPeriodRecognized(beginRaw, endRaw) {
  const begin = (beginRaw || "").trim();
  const end = (endRaw || "").trim();
  if (!begin || !end) {
    return "请填写身份证有效期";
  }
  const beginDate = parseIdCardDate(begin);
  if (!beginDate) {
    return "身份证有效期起格式不正确";
  }
  if (isLongTerm(end)) {
    return null;
  }
  const endDate = parseIdCardDate(end);
  if (!endDate) {
    return "身份证有效期止格式不正确";
  }
  if (beginDate.getTime() > endDate.getTime()) {
    return "身份证有效期起止不正确";
  }
  return null;
}

/**
 * 身份证有效期校验（与后端 IdCardValidPeriodUtil 对齐，含未过期）
 * @returns {string|null} 错误文案，通过返回 null
 */
export function validateIdCardValidPeriod(beginRaw, endRaw) {
  const recognizedErr = validateIdCardValidPeriodRecognized(beginRaw, endRaw);
  if (recognizedErr) {
    return recognizedErr;
  }
  const end = (endRaw || "").trim();
  if (isLongTerm(end)) {
    return null;
  }
  const endDate = parseIdCardDate(end);
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  if (endDate && endDate.getTime() < today.getTime()) {
    return "身份证已过期，请使用在有效期内的证件";
  }
  return null;
}

function isLongTerm(end) {
  const n = String(end || "")
    .trim()
    .replace(/\s/g, "");
  return (
    n === "长期" ||
    n === "永久" ||
    n === "长期有效" ||
    /^long(-term)?$/i.test(n)
  );
}

function parseIdCardDate(raw) {
  const s = String(raw || "").trim();
  if (!s || isLongTerm(s)) return null;
  const normalized = s.replace(/[./]/g, "-");
  const m = normalized.match(/^(\d{4})-(\d{1,2})-(\d{1,2})$/);
  if (m) {
    const y = Number(m[1]);
    const mo = Number(m[2]);
    const d = Number(m[3]);
    const dt = new Date(y, mo - 1, d);
    if (dt.getFullYear() === y && dt.getMonth() === mo - 1 && dt.getDate() === d) {
      dt.setHours(0, 0, 0, 0);
      return dt;
    }
    return null;
  }
  if (/^\d{8}$/.test(s)) {
    const y = Number(s.slice(0, 4));
    const mo = Number(s.slice(4, 6));
    const d = Number(s.slice(6, 8));
    const dt = new Date(y, mo - 1, d);
    if (dt.getFullYear() === y && dt.getMonth() === mo - 1 && dt.getDate() === d) {
      dt.setHours(0, 0, 0, 0);
      return dt;
    }
  }
  return null;
}
